const createField = (question) => {
	const wrapper = document.createElement('div');
	wrapper.className = 'apply-form__question';
	wrapper.dataset.questionId = String(question.id);

	const label = document.createElement('label');
	label.textContent = question.question;
	label.htmlFor = `sg-question-${question.id}`;
	wrapper.appendChild(label);

	let input;

	switch (question.type) {
		case 'TEXTAREA':
			input = document.createElement('textarea');
			input.rows = 4;
			break;
		case 'YESNO':
		case 'CATALOG':
			input = document.createElement('select');
			(input).innerHTML = '<option value=""></option>';
			(question.answerCatalog || []).forEach((answer) => {
				const option = document.createElement('option');
				option.value = answer;
				option.textContent = answer;
				input.appendChild(option);
			});
			input.required = true;
			break;
		default:
			input = document.createElement('input');
			input.type = 'text';
	}

	input.id = `sg-question-${question.id}`;
	input.name = `question_${question.id}`;
	input.required = true;
	input.dataset.questionType = question.type;
	wrapper.appendChild(input);

	return wrapper;
};

export const renderQuestions = (container, questions, fieldset) => {
	if (!container) return;

	container.innerHTML = '';

	if (!questions || questions.length === 0) {
		fieldset?.setAttribute('hidden', '');
		return;
	}

	fieldset?.removeAttribute('hidden');
	questions.forEach((question) => {
		container.appendChild(createField(question));
	});
};

export const collectAnswers = (container) => {
	const answers = [];

	container?.querySelectorAll('.apply-form__question').forEach((wrapper) => {
		const input = wrapper.querySelector('input, select, textarea');
		if (!input || !input.value.trim()) return;

		answers.push({
			questionId: Number(wrapper.dataset.questionId),
			answer: input.value.trim(),
		});
	});

	return answers;
};
